/**
 * 二手车采购员管理
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip } from 'antd';
import PageLayout from '../../ui/PageLayout';
//会员选择信息
import MemberTeam from './ProcurementPermissionTeam';
import { global_data } from '../../ui/auth'



class ProcurementPermissionIndex extends React.Component {

    columns = [{
        title: '姓名',
        dataIndex: 'name',
        width: '10%',
    }
    ,{
        title: '用户名',
        dataIndex: 'userName',
        width: '10%',
    }
    ,{
        title: '所属会员',
        dataIndex: 'memberName',
        width: '10%',
    }
    ,{
        title: '操作',
        width: '5%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("PROCUREMENT_PERMISSIONS_UPDATE")?
                <Tooltip title="会员下用户配置">
                    <Icon type="team" className="table-operate-icon" onClick={this.updateTeam.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        queryData: {},
        teamVisible: false,
    };

    //会员下的人员设置
    updateTeam = (info, e) => {
        this.refs["memberTeam"].initData(info.userName,
            (res) => { this.setState({  teamVisible: true }) }
        );
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="姓名"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 300 }}
                                />
                            </Col>
                        </Row>
                    )}
                    rowKey="userName"
                    url="/procurement/permission/query/procurementPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />

                <MemberTeam
                    visible={this.state.teamVisible}
                    onCancel={() => { this.setState({ teamVisible: false }) }}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    ref="memberTeam"
                    content="member"
                />
            </div>
        )
    }
}

export default ProcurementPermissionIndex;